import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import {
  Form,
  SidebarFormHeader,
  TextfieldElement,
  SelectElement,
  SidebarFormFooter,
  withAuthentication,
  withProvidersApi,
  AutocompleteTextfieldApiElement,
} from "cw-styleguide-react";
import withAssets from "../../../../components/hoc/withAssets";
import i18n from "../../../../i18n";
import {
  STATUS_AWAITING_AMENDMENTS,
  STATUS_AWAITING_TRANSLATION,
  TRANSLATOR_UNASSIGNED,
} from "../../../../constants";

class CoursesManageTranslateFilterForm extends Component {
  render() {
    return (
      <Form theme={["sidebar"]} classes={["sidebar--can-collapse"]}>
        <SidebarFormHeader
          heading={this.props.t("styleguide:forms.filterBy")}
          searchButtonText={this.props.t("styleguide:forms.applyFilters")}
          handleSubmit={this.props.handleSubmit}
          handleReset={this.props.handleReset}
        />
        <div className="form__body">
          {/* courseId */}
          <TextfieldElement
            id={"courseId"}
            name={"courseId"}
            label={this.props.t(
              "view.courses.translateManage.filters.courseId.label"
            )}
            value={this.props.filterValues.courseId}
            onChange={this.props.handleChange}
          />
          {/* courseTitle */}
          <TextfieldElement
            id={"courseTitle"}
            name={"courseTitle"}
            label={this.props.t(
              "view.courses.translateManage.filters.courseTitle.label"
            )}
            value={this.props.filterValues.courseTitle}
            onChange={this.props.handleChange}
          />

          {/* Status */}
          <SelectElement
            size={"medium"}
            label={this.props.t(
              "local:view.courses.translateManage.filters.courseStatus.label"
            )}
            id={"statuses"}
            name={"statuses"}
            value={this.props.filterValues.statuses}
            onChange={this.props.handleChange}
            grouped={true}
            options={[
              {
                value: "",
                label: this.props.t("styleguide:forms.all"),
              },
              {
                value: STATUS_AWAITING_TRANSLATION,
                label: this.props.courses.getStatusName(
                  STATUS_AWAITING_TRANSLATION
                ),
              },
              {
                value: STATUS_AWAITING_AMENDMENTS,
                label: this.props.courses.getStatusName(
                  STATUS_AWAITING_AMENDMENTS
                ),
              },
            ]}
          />

          {/* Main Provider */}
          <AutocompleteTextfieldApiElement
            api={this.props.providersApiGetEndpoint("providers_api_provider")}
            authorize={true}
            size={"large"}
            name={"mainProvider"}
            label={this.props.t(
              "local:view.courses.translateManage.filters.mainProvider.label"
            )}
            queryParameter={"name"}
            acceptLanguage={i18n.language}
            keyField={"atlasAccountId"}
            valueField={"providerName"}
            placeholder={this.props.t(
              "local:view.courses.translateManage.filters.mainProvider.placeholder"
            )}
            value={this.props.filterValues.mainProviderId}
            keyword={this.props.filterValues.mainProviderLabel}
            onChange={this.props.handleChange}
          />

          {/* Assigned */}
          <SelectElement
            size={"medium"}
            label={this.props.t(
              "local:view.courses.translateManage.filters.translatorAssigned.label"
            )}
            id={"translatorAssigned"}
            name={"translatorAssigned"}
            value={this.props.filterValues.translatorAssigned}
            onChange={this.props.handleChange}
            grouped={true}
            options={
              this.props.authentication.hasRole("Courses_TranslatorManager")
                ? [
                    {
                      value: "",
                      label: this.props.t("styleguide:forms.all"),
                    },
                    {
                      value: TRANSLATOR_UNASSIGNED,
                      label: this.props.t("styleguide:forms.unassigned"),
                    },
                  ].concat(this.props.translators)
                : [
                    {
                      value: TRANSLATOR_UNASSIGNED,
                      label: this.props.t("styleguide:forms.unassigned"),
                    },
                  ].concat(this.props.translators)
            }
          />
          <SidebarFormFooter
            handleSubmit={this.props.handleSubmit}
            handleReset={this.props.handleReset}
            searchButtonText={this.props.t("styleguide:forms.applyFilters")}
          />
        </div>
      </Form>
    );
  }
}

export default withProvidersApi(process.env)(
  withAssets(
    withAuthentication(
      withTranslation("local")(CoursesManageTranslateFilterForm)
    )
  )
);
